import {
  Flex,
  Tab,
  TabIndicator,
  TabList,
  TabPanel,
  TabPanels,
  Tabs,
  Text,
} from "@chakra-ui/react";
import { useQuery } from "@tanstack/react-query";
import { useCallback, useContext, useEffect, useState } from "react";
import { AppContext } from "../../../../../contexts/AppContext";
import { GET_HISTORY, GET_REQUESTS } from "../../../../../apis/constants.api";
import { getHistory, getRequests } from "../../../../../apis/vmRequests.api";
import { isSysAdmin } from "../../../../../utils/users.utils";
import RequestsTable from "../RequestsTable";
import HistoryTable from "../HistoryTable";

const Listing = () => {
  const PAGE_SIZE = process.env.REACT_APP_PAGE_SIZE;
  const [page, setPage] = useState(1);
  const [stateApp] = useContext(AppContext);
  const { user } = stateApp;
  const [activeTab, setActiveTab] = useState(0);

  const {
    data: instanceRequestsList,
    refetch: instanceRequest,
    isFetching: isRequestsLoading,
    isInitialLoading: isRequestsInitialLoading,
  } = useQuery({
    queryKey: [
      GET_REQUESTS,
      {
        skip: PAGE_SIZE * (page - 1),
        limit: PAGE_SIZE,
      },
    ],
    queryFn: getRequests,
    enabled: true && isSysAdmin(user), // Only fetch if user is system admin
  });

  const {
    data: instanceHistoryList,
    refetch: instanceHistory,
    isFetching: isHistoryLoading,
    isInitialLoading: isHistroyInitialLoading,
  } = useQuery({
    queryKey: [
      GET_HISTORY,
      {
        skip: PAGE_SIZE * (page - 1),
        limit: PAGE_SIZE,
      },
    ],
    queryFn: getHistory,
    enabled: false,
  });

  useEffect(() => {
    setPage(1);
  }, []);

  // const totalPages = requests?.data.totalSkills / PAGE_SIZE;
  const requestsList = instanceRequestsList?.data.data.instanceRequests || [];
  const totalPages = 0 / PAGE_SIZE;
  const historyList = instanceHistoryList?.data.data.instanceHistory || [];

  const handlePageChange = useCallback((data) => {
    setPage(data.selected + 1);
  }, []);

  const handleTabClick = (index) => {
    setActiveTab(index);

    if (!isSysAdmin(user)) return;

    const fetchFn = index === 0 ? instanceRequest : instanceHistory;
    fetchFn();
  };

  return (
    <Tabs
      position="relative"
      variant="unstyled"
      mt="20px"
    >
      <Flex
        justifyContent="space-between"
        borderBottom="1px solid #E3E4E8"
        pb="10px"
        flexWrap={{ md: "wrap-reverse", "2xl": "nowrap" }}
        gap="20px"
      >
        <TabList width={{ base: "100%", xl: "auto" }} display="contents">
          <Flex gap={{ xl: "45px" }} width={{ base: "100%", xl: "auto" }}>
            <Tab
              onClick={() => handleTabClick(0)}
              color={activeTab === 0 ? "#713EDD" : "#868B94"}
              flex={{ base: "1", xl: "none" }}
            >
              <Flex
                alignItems="center"
                justifyContent="center"
                gap={{ base: "5px", xl: "12px" }}
              >
                <Text
                  fontSize={{ base: "fs.14", lg: "fs.16" }}
                  whiteSpace="nowrap"
                  fontWeight="fw.400"
                >
                  Instance request
                </Text>
              </Flex>
            </Tab>
            <Tab
              flex={{ base: "1", xl: "none" }}
              onClick={() => handleTabClick(1)}
              color={activeTab === 1 ? "#713EDD" : "#868B94"}
            >
              <Flex
                alignItems="center"
                justifyContent="center"
                gap={{ base: "5px", xl: "12px" }}
              >
                <Text
                  fontSize={{ base: "fs.14", lg: "fs.16" }}
                  fontWeight="fw.400"
                >
                  Instance history
                </Text>
              </Flex>
            </Tab>
          </Flex>
        </TabList>
      </Flex>

      <TabIndicator
        mt="-4.5px"
        height="4px"
        bg="#713EDD"
        width="auto"
        borderRadius="1px"
      />
      <TabPanels
        height="-webkit-fill-available"
        overflowY="scroll"
        className="scrollBar"
      >
        <TabPanel>
          <RequestsTable
            handlePageChange={handlePageChange}
            page={page}
            requestsList={requestsList}
            totalPages={totalPages}
            isLoading={isRequestsLoading}
            isInitialLoading={isRequestsInitialLoading}
          />
        </TabPanel>
        <TabPanel>
          <HistoryTable
            handlePageChange={handlePageChange}
            page={page}
            historyList={historyList}
            totalPages={totalPages}
            isLoading={isHistoryLoading}
            isInitialLoading={isHistroyInitialLoading}
          />
        </TabPanel>
      </TabPanels>
    </Tabs>
  );
};

export default Listing;
